export default "__VITE_ASSET__e09f0a84__"